import api from "../axios/api";
import { IPayload } from "../models/ipayload";
import Axios from "axios";
import { IEquipmentModel } from "../models/iequipmentModel";
let CancelToken = Axios.CancelToken;
let fetchEquipmentModels_cancel: any;
let fetchEquipmentModelsById_cancel: any;



export const fetchEquipmentModelsService = (page: number, limit: number, search: string, order: string, orderBy: string, documenttypeId: string): Promise<IPayload<IEquipmentModel>> => {
  fetchEquipmentModels_cancel && fetchEquipmentModels_cancel()
  const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}${documenttypeId ? `&documenttype=${documenttypeId}` : ''}`;
  return api.get('/equipmentmodels' + queryParams, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipmentModels_cancel = c;
    })
  })
}


export const fetchEquipmentModelsByIdService = (id: string): Promise<IEquipmentModel> => {
  fetchEquipmentModelsById_cancel && fetchEquipmentModelsById_cancel()
  return api.get('/equipmentmodels/' + id, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipmentModelsById_cancel = c;
    })
  })
}



